import { useRouter } from "hooks";

export default function useError() {
  const router = useRouter();
  const verifyError = (error: any) => {
    // if (error === 500) {
    //   return router.push("/error");
    // }
    if (error === 401) {
      return router.push("/sessao-expirada");
    }
  };

  return { verifyError };
}
